<template>
	<div style="padding: 20px;" v-loading="show_loading" :element-loading-text="'上传中('+upload_percent+'%)...'"
		element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)">
		<el-row :gutter="20">
			<el-col :span="12">
				<div class="centext-box">
					<div class="header">
						上传文件
					</div>
					<div style="padding: 20px;" class="form">
						<el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="80px"
							class="demo-ruleForm" label-position="right">
							<el-form-item label="选择文件" prop="name">
								<div style="display: flex;flex-direction: column;">
									<el-upload class="upload-demo" ref="upload"
										action="https://jsonplaceholder.typicode.com/posts/" :multiple="false"
										:show-file-list="false" :before-upload="beforeUpload">
										<el-button slot="trigger" size="small" type="primary">选取文件</el-button>
									</el-upload>
									<span style="font-size: 14px;color: #fff;">{{ruleForm.name}}</span>
								</div>
							</el-form-item>
							<el-form-item label="备注">
								<el-input type="text" placeholder="请输入备注" size="small" v-model="ruleForm.one"
									style="width: 300px;"></el-input>
							</el-form-item>
							<el-form-item>
								<el-button type="primary" size="small" @click="submitForm('ruleForm')">上传</el-button>
							</el-form-item>
						</el-form>
					</div>
				</div>
			</el-col>
			<el-col :span="12">
				<div class="centext-box">
					<div class="header">
						收费标准
					</div>
					<div style="padding: 20px;">
						<div style="margin-bottom: 10px;">收费分为两部分，1：文件存储费用。2：文件下载费用。</div>
						<div style="margin-bottom: 10px;">文件存储费用以及规则：
							1mb/0.01元(每月)，就是说：这个文件10mb，那么，每个月会从余额中扣除0.1元，余额不足则删除文件，不足1mb的文件，按照1m算</div>
						<div>文件下载费用以及规则：
							10mb/0.01元，就是说：这个文件10mb，那么，用户每下载一次这个文件，就会从余额中扣除0.01元，不足10mb的文件，按照10m算，余额不足则无法下载。</div>
					</div>
				</div>
			</el-col>
		</el-row>
	</div>
</template>

<script>
	import axios from 'axios'
	export default {
		data() {
			return {
				id: null,
				file: null,
				ruleForm: {
					one: '',
					name: '',
					size: '',
					type: 'create',
				},
				upload_percent: 0,
				show_loading: false,
				rules: {
					name: [{
						required: true,
						message: '请选择要上传的文件',
						trigger: 'change'
					}],
					one: [{
						required: true,
						message: '请输入文件备注',
						trigger: 'blur'
					}],
				},
			}
		},
		created() {
			this.resetForm()
		},
		methods: {
			beforeUpload(file) {
				console.log(file);
				this.ruleForm.name = file.name
				this.ruleForm.size = file.size
				this.file = file
				return false
			},
			async submitForm() {
				this.$refs['ruleForm'].validate((valid) => {
					if (valid) {
						this.$H.post('verify_center/v1_0_1.Files/GetUploadInfo', {
							one: this.ruleForm.one,
							name: this.ruleForm.name,
							size: this.ruleForm.size,
							type: this.ruleForm.type,
							file_id: 0,
						}).then(async res => {
							console.log(res)
							if (!res.data) return;
							console.log(res.data.info)
							await this.uploadFile(this.file,res.data.info)
							// let data = {
							// 	...res.data.info,
							// 	file: this.file
							// }
							// axios.post(res.data.info.host, data, {
							// 	headers: {
							// 		'Content-Type': 'multipart/form-data'
							// 	},
							// 	onUploadProgress: (data) => {
							// 		let {
							// 			progress
							// 		} = data
							// 		this.upload_percent = (progress * 100).toFixed(2)
							// 		if (progress == 1) {
							// 			this.show_loading = false
							// 		} else {
							// 			this.show_loading = true
							// 		}
							// 	}
							// }).then(res => {
							// 	this.$message.success('上传成功')
							// 	console.log(res)

							// }).catch(err => {
							// 	console.log(err)
							// })
						})
					} else {
						console.log('error submit!!');
						return false;
					}
				});
			},
			async uploadFile(file,policyAndSignature) {
				// 获取临时访问策略（policy）和签名（signature）
				let {
					host,
					policy,
					signature,
					OSSAccessKeyId,
					key,
					callback,
					order_id
				} = policyAndSignature;

				if (!policy || !signature) {
					console.error('无法获取临时访问策略和签名');
					return;
				}


				try {
					// 构造表单数据
					const formData = new FormData();
					formData.append('key', key);
					formData.append('policy', policy);
					formData.append('OSSAccessKeyId', OSSAccessKeyId);
					formData.append('signature', signature);
					formData.append('file', file);
					formData.append('success_action_status',200)

					// 使用 POST 请求上传文件
					host = host+'?callback='+callback
					console.log(host)
					const response = await axios.post(host,
						formData,
					);
					
					this.$H.post('verify_center/v1_0_1.Files/UploadSuccessNotify', {
						order_id:order_id,
						size: this.ruleForm.size,
					}).then(res=>{
						this.$message.success('文件上传成功！')
						this.$emit('back')
					})
					return response
				} catch (error) {
					console.error('文件上传失败：', error);
				}
			},
			resetForm() {
				this.$nextTick(() => {
					this.$refs['ruleForm'].resetFields();
				})
			}
		}
	}
</script>

<style scoped>
	.centext-box {
		border-radius: 5px;
		background-color: rgb(66, 75, 79);
		color: #fff
	}

	.centext-box .header {
		font-size: 14px;

	}

	.form>>>.el-form-item__label {
		color: #fff !important;
	}

	.form>>>.el-input__inner {
		background-color: rgb(66, 75, 79);
		border: 1px solid #ccc !important;
		color: #fff;
	}

	.form>>>.el-radio__label {
		color: #fff;
	}

	.form>>>.el-textarea__inner {
		background-color: rgb(66, 75, 79);
		border: 1px solid #ccc !important;
		color: #fff;
	}
</style>